import { Pipe, PipeTransform, ChangeDetectorRef } from "@angular/core";

@Pipe({ 
    name: 'translateweb',
    pure: false
})
export class TranslatePipeWeb implements PipeTransform {
    private cache: { [key: string]: any } = {};
    private lastValue: string = '';
    private lastKey: string = '';
    private lastResult: string = '';

    constructor(private cd: ChangeDetectorRef) {}

    private loadTranslations(language: string): any {
        const lang = language.toLowerCase();
        if (!this.cache[lang]) {
            try {
                const translations = require(`./languages/${lang}.json`);
                this.cache[lang] = translations;
            } catch (err) {
                console.error(`Missing translation file: ${lang}.json`);
                return null;
            }
        }
        return this.cache[lang];
    }

    toTitleCase(str) {
        return str.toLowerCase().replace(/(?:^|\s)\w/g, function (match) {
            return match.toUpperCase();
        });
    }

    swapVariables(value: string, var1: string) {
        if (var1) {
            value = value.replace("$$$$1", this.toTitleCase(var1))
        }
        return value;
    }

    transform(value: string, translateTo: string, shouldTranslate: boolean, replaceVar1: string): string {
        if (!value) return '';

        if(value === 'RSVP'){
            
        }
        
        const key = `${value}-${translateTo}-${shouldTranslate}-${replaceVar1}`;
        if (this.lastKey === key) {
            return this.lastResult;
        }

        let language = 'en';

        if (!shouldTranslate || !translateTo) {
            this.lastKey = key;
            this.lastResult = this.swapVariables(value, replaceVar1);
            return this.lastResult;
        }

        language = translateTo;
        const lang = language.toLowerCase();

        if (language === 'en' || !this.cache[lang]) {
            if (language !== 'en') {
                const translations = this.loadTranslations(lang);
                if (translations) {
                    setTimeout(() => this.cd.markForCheck(), 0);
                }
            }
            this.lastKey = key;
            if (replaceVar1){
                const translated = this.cache[lang][value];
            this.lastResult = this.swapVariables(translated, replaceVar1);
            return this.lastResult;
            }
            
        }

        const translated = this.cache[lang][value];
        this.lastKey = key;
        this.lastResult = this.swapVariables(translated || value, replaceVar1);
        return this.lastResult;
    }
}





// WEBPACK FOOTER //
// ./src/app/translator/translator-pipe-web.ts